/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { DidCommMessageBlobDescriptor } from './DidCommMessageBlobDescriptor';

export const DidCommMessageCreateBlobs: core.serialization.ObjectSchema<
    serializers.DidCommMessageCreateBlobs.Raw,
    Truvity.DidCommMessageCreateBlobs
> = core.serialization.object({
    messages: core.serialization.list(DidCommMessageBlobDescriptor),
});

export declare namespace DidCommMessageCreateBlobs {
    export interface Raw {
        messages: DidCommMessageBlobDescriptor.Raw[];
    }
}
